import React from "react";
import styles from "./SearchInput.module.css";
import { Iconfont } from "../Iconfont";

export interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
}

export function SearchInput({
  value,
  onChange,
  placeholder = "搜索",
  className = "",
  disabled = false,
}: SearchInputProps) {
  return (
    <div className={`${styles.searchInput} ${className}`}>
      <Iconfont icon="serach" className={styles.searchIcon} />
      <input
        type="text"
        className={styles.input}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
      />
      {value && (
        <button
          className={styles.clearButton}
          onClick={() => onChange("")}
          type="button"
          disabled={disabled}
        >
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path
              d="M9 3L3 9M3 3L9 9"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      )}
    </div>
  );
}
